import { useMutation } from '@tanstack/react-query';
import api from '../../services/api';
import queryClient from '../queryClient';

export type PlanogramStatus = 'lockSold' | 'unlocked' | 'lock';

export type CreateProductFromPlanogramParams = {
    product_id: number;
    storeIds: Array<string>;
    planogram_code: string;
    status: PlanogramStatus;
    price_list_in_cents: number;
    price_final_in_cents: number;
    standard_amount: number;
    alert_level: number;
    stock_amount: number;
};

export function useCreateProductFromPlanogram() {
    const mutationFn = async (data: CreateProductFromPlanogramParams) => {
        const response = await api.post(`/products/create-planograms`, data);
        return response.data;
    };

    return useMutation({
        mutationFn,
        retry: false,
        onSuccess: () => {
            queryClient.invalidateQueries(['GET_PLANOGRAMS_BY_PRODUCT']);
        },
    });
}
